(function() {

    const ACTIVE_ITEM_CLASS = 'current-active-archive';
    const HEADER_SCROLL_OFFSET_PX = 120;
    const SCROLL_POSITION_OFFSET_PX = 50;

    function makeScrollTocLinkHandler(tocList, scrollPos) {
        return function(link) {
            const targetId = link.getAttribute('href');
            const target = document.querySelector(targetId);

            if (target) {
                const targetTop = target.offsetTop;
                const targetBottom = targetTop + target.offsetHeight;

                if (scrollPos >= targetTop && scrollPos < targetBottom) {
                    // Remove active from all
                    tocList.querySelectorAll('.list-item').forEach(function(item) {
                        item.classList.remove(ACTIVE_ITEM_CLASS);
                    });
                    // Add active to current
                    link.parentElement.classList.add(ACTIVE_ITEM_CLASS);
                }
            }
        };
    }

    document.addEventListener('DOMContentLoaded', function() {
        const tocList = document.querySelector('.em-event .side-bar-category__list');

        if (!tocList) { return; }

        // Find all .em-event-title elements
        const titles = document.querySelectorAll('.em-event-title');

        titles.forEach(function(title, index) {
            const titleText = title.textContent.trim();
            let titleId = title.getAttribute('id');

            // If no ID exists, create one
            if (!titleId) {
                titleId = 'event-section-' + index;
                title.setAttribute('id', titleId);
            }

            // Create list item
            const listItem = document.createElement('li');
            listItem.className = 'list-item toc-level-2';
            if (index === 0) {
                listItem.classList.add(ACTIVE_ITEM_CLASS);
            }

            // Create anchor
            const anchor = document.createElement('a');
            anchor.href = '#' + titleId;
            anchor.textContent = titleText;

            listItem.appendChild(anchor);
            tocList.appendChild(listItem);
        });

        // Add Comments section if it exists
        const commentsSection = document.querySelector('.em-event-comments');
        const commentsArea = document.querySelector('.comments-area, .comment-form');

        if (commentsSection && commentsArea) {
            const commentsId = 'event-comments-section';
            commentsSection.setAttribute('id', commentsId);

            const commentsItem = document.createElement('li');
            commentsItem.className = 'list-item toc-level-2';
            commentsItem.innerHTML = '<a href="#' + commentsId + '">Comments</a>';
            tocList.appendChild(commentsItem);
        }

        // Smooth scroll for TOC links
        tocList.addEventListener('click', function(e) {
            if (e.target.tagName === 'A') {
                e.preventDefault();

                const targetId = e.target.getAttribute('href');
                const target = document.querySelector(targetId);

                if (target) {
                    // Remove active class from all items
                    const allItems = tocList.querySelectorAll('.list-item');
                    allItems.forEach(function(item) {
                        item.classList.remove(ACTIVE_ITEM_CLASS);
                    });

                    // Add active class to clicked item
                    e.target.parentElement.classList.add(ACTIVE_ITEM_CLASS);

                    // Smooth scroll to target using constant offset
                    const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - HEADER_SCROLL_OFFSET_PX;
                    window.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth'
                    });
                }
            }
        });

        // Update active TOC item on scroll
        let scrollTimeout;
        window.addEventListener('scroll', function() {
            if (scrollTimeout) {
                window.cancelAnimationFrame(scrollTimeout);
            }

            scrollTimeout = window.requestAnimationFrame(function() {
                const scrollPos = window.pageYOffset + SCROLL_POSITION_OFFSET_PX;
                const tocLinks = tocList.querySelectorAll('a');

                tocLinks.forEach(makeScrollTocLinkHandler(tocList, scrollPos));
            });
        });
    });
})();
